import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  InputGroup,
  InputGroupText,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Triangle } from "react-loader-spinner";

import DeleteModal from "../../../Components/Common/DeleteModal";
import toast from "react-hot-toast";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import Select from "react-select";
import SectionService from "../../../services/OrderingServices/SectionService";
import CreateSection from "../component/CreateSection";
import { Link, useNavigate } from "react-router-dom";
import useIsSmallScreen from "../../Payment Type/Component/small screen/SmallScreen";

import useTableSearch from "../../../hooks/useTableSearch";
import TableSearch from "../../../Components/Common/TableSearch";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const Section = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTable, setSelectedTable] = useState(null);
  const isSmallScreen = useIsSmallScreen();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [showSections, setShowSections] = useState(() => {
  //   const saved = localStorage.getItem("shouldShowSections"); // key from login
  //   return saved !== null ? JSON.parse(saved) : true; // default true if not set
  // });

  const [showSections, setShowSections] = useState(
    () => JSON.parse(localStorage.getItem("user"))?.shouldShowSections ?? true
  );

  const fetchTable = async () => {
    setLoading(true);
    try {
      const response = await SectionService.getList();
      setData(response);
    } catch (error) {
      toast.error("Failed to fetch table data");
    } finally {
      setLoading(false);
    }
  };
  // console.log(data)
  useEffect(() => {
    fetchTable();
  }, []);
  const handleToggle = () => {
    const user = JSON.parse(localStorage.getItem("user")) || {};
    const updated = !user.shouldShowSections;

    user.shouldShowSections = updated;
    localStorage.setItem("user", JSON.stringify(user));

    setShowSections(updated); // 🔥 triggers re-render
  };
  const toggleModal = (row = null) => {
    setSelectedTable(row);
    setIsModalOpen(!isModalOpen);
  };

  const toggleDeleteModal = () => setDeleteModal(!deleteModal);

  const handleDeleteClick = (id) => {
    setSelectedDeleteItem(id);
    toggleDeleteModal();
  };

  const handleDelete = async () => {
    try {
      const response = await SectionService.delete(selectedDeleteItem);
      setData((prev) => prev.filter((item) => item.id !== selectedDeleteItem));
      toast.success("Selected section is deleted successfull");
    } catch (error) {
      console.log("🚀 ~ handleDelete ~ error:", error);
      toast.error(error?.response?.data?.details);
    } finally {
      toggleDeleteModal();
      setSelectedDeleteItem(null);
    }
  };
  const hideSectionsForUser = () => {
    const user = JSON.parse(localStorage.getItem("user")) || {};

    user.shouldShowSections = false;

    localStorage.setItem("user", JSON.stringify(user));
  };

  const getStatusBadge = (e) => {
    const statusStyles = {
      Occupied: "bg-danger",
      Available: "bg-success",
      Reserved: "bg-dark",
    };
    return (
      <span className={`badge ${statusStyles[e] || "bg-danger"}`}>
        {e || "No Data"}
      </span>
    );
  };
  const columns = [
    {
      name: "S.N",
      selector: (row, index) => (currentPage - 1) * rowsPerPage + (index + 1),
      width: "75px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
    },
    // {
    //   name: "Status",
    //   selector: (row) => getStatusBadge(row.tableStatus),
    //   sortable: true,
    // },
    {
      name: "Action",
      cell: (row) => (
        <ButtonGroup size="sm">
          <Link to={`/section/detail/${row.id}`}>
            <Button color="btn btn-soft-success" className="btn-sm">
              <i className="bx bx-show" />
            </Button>
          </Link>

          <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            onClick={() => toggleModal(row)}
          >
            <i className="ri-edit-line" />
          </Button>
          <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button>
        </ButtonGroup>
      ),
      center: true,
    },
  ];

  const { searchTerm, setSearchTerm, filteredData } = useTableSearch(data, [
    "name",
    "description",
  ]);

  const [filterText, setFilterText] = useState("");
  const [statusFilter, setStatusFilter] = useState(null); // <-- NEW

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };
  const handleStatusChange = (selectedOption) => {
    setStatusFilter(selectedOption);
  };
  // const filteredData = data?.filter((pkg) => {
  //   const searchContext = `${pkg?.name || ""} `.toLowerCase();

  //   const matchesText = searchContext.includes(filterText.toLowerCase());
  //   // const matchesStatus = statusFilter
  //   //   ? pkg.tableStatus.toLowerCase() === statusFilter.label.toLowerCase()
  //   //   : true;

  //   return matchesText;
  // });
  console.log(filteredData);
  const statusOptions = [
    { value: "Available", label: "Available" },
    { value: "Occupied", label: "Occupied" },
    { value: "Reserved", label: "Reserved" },
    // { value: "Cancelled", label: "Cancelled" },
  ];

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Section" pageTitle="System Setup" />

        <div
          className="p-3 p-lg-4 mt-1"
          style={{
            background: "#fff",
            borderRadius: "0.5rem",
            boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
            border: "1px solid #eee",
          }}
        >
          {/* Filter Button */}
          <Row className="justify-content-between align-content-center align-items-center ">
            <Col md={6} className="align-items-center">
              <h5 className="mb-1 fw-bold text-dark ">Sections List</h5>
            </Col>
            <Col md={6} className="mb-3">
              <div className="d-flex justify-content-end align-content-center align-items-center gap-3">
                {/* <Button
                  color={showSections ? "danger" : "primary"}
                  onClick={handleToggle}
                  className="d-flex align-items-center gap-2"
                  style={{ borderRadius: "8px" }}
                >
                  {showSections ? "Hide" : "Show"}
                </Button> */}
                <div className="d-flex align-items-center justify-content-end">
                  <TableSearch
                    value={searchTerm}
                    onChange={setSearchTerm}
                    placeholder="Search by all.."
                  />
                </div>
                <Button
                  color="success"
                  onClick={() => toggleModal()}
                  className="d-flex align-items-center gap-2"
                  style={{ borderRadius: "8px" }}
                >
                  <i className="bx bx-plus"></i> Add
                </Button>
              </div>
            </Col>
            {/* </div> */}
          </Row>

          {isSmallScreen ? (
            loading ? (
              <div className="d-flex justify-content-center my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                />
              </div>
            ) : (
              <>
                {filteredData?.map((item, index) => (
                  <Card
                    key={item.id || index}
                    className="mb-3 shadow-sm d-block d-lg-none"
                    onClick={(e) => {
                      e.stopPropagation(); // prevents parent click handlers

                      navigate(`/section/detail/${item?.id}`);
                    }}
                  >
                    <CardBody>
                      <Row>
                        <Col xs={10}>
                          <h6 className="mb-2">Section: {`${item.name}`}</h6>
                          {/* <h6 className="mb-2 text-muted">
                      Parent Section: {item?.name}
                    </h6> */}
                          <h6 className="mb-2 text-muted">
                            Description: {item?.description}
                          </h6>
                          <span
                            className={`badge ${
                              item.isActive ? "bg-success" : "bg-danger"
                            }`}
                          >
                            {item.isActive ? "Active" : "Inactive"}
                          </span>{" "}
                        </Col>
                        <Col xs={2}>
                          <div>
                            <Dropdown
                              isOpen={item.dropdownOpen || false}
                              toggle={(e) => {
                                e.stopPropagation(); // prevents parent click handlers

                                setData((prev) =>
                                  prev.map(
                                    (sectiondata) =>
                                      sectiondata.id === item.id
                                        ? {
                                            ...sectiondata,
                                            dropdownOpen:
                                              !sectiondata.dropdownOpen,
                                          }
                                        : {
                                            ...sectiondata,
                                            dropdownOpen: false,
                                          } // close all others
                                  )
                                );
                              }}
                              direction="down"
                            >
                              <DropdownToggle
                                color="primary"
                                outline
                                className="btn-sm  shadow-sm rounded-circle"
                              >
                                <i className="ri-more-2-fill"></i>
                              </DropdownToggle>
                              <DropdownMenu end>
                                <DropdownItem
                                  onClick={(e) => {
                                    e.stopPropagation(); // prevents parent click handlers
                                    toggleModal(item); // opens your modal with the item
                                  }}
                                >
                                  <i className="ri-edit-line text-warning me-2"></i>{" "}
                                  Edit
                                </DropdownItem>
                                <DropdownItem
                                  onClick={(e) => {
                                    e.stopPropagation(); // prevents parent click handlers
                                    handleDeleteClick(item.id);
                                  }}
                                >
                                  <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                                  Delete
                                </DropdownItem>
                              </DropdownMenu>
                            </Dropdown>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                ))}
              </>
            )
          ) : (
            <CustomDataTable
              responsive
              striped
              pagination
              onChangePage={(page) => setCurrentPage(page)}
              onChangeRowsPerPage={(newPerPage) => {
                setRowsPerPage(newPerPage);
                setCurrentPage(1);
              }}
              fixedHeader
              persistTableHead
              progressPending={loading}
              customStyles={customStyles}
              progressComponent={
                <div className="my-3 text-center">
                  <Triangle
                    visible={true}
                    height="80"
                    width="80"
                    color="#5B71B9"
                  />
                  <h5 className="mt-1">Loading...</h5>
                </div>
              }
              columns={columns}
              data={filteredData}
              noDataComponent={
                <div className="text-center my-5 w-100">
                  <i className="ri-emotion-unhappy-line display-4 text-secondary" />
                  <h5 className="fw-semibold text-secondary">
                    No data Available
                  </h5>
                  <p className="text-muted mb-0">No Sections found.</p>
                </div>
              }
            />
          )}
        </div>
      </div>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
      />

      <CreateSection
        isOpen={isModalOpen}
        toggle={toggleModal}
        selectedTable={selectedTable}
        refreshData={fetchTable}
      />
    </Container>
  );
};

export default Section;
